export default "__VITE_ASSET__DxsqERKg__"